export var ServiceWorkerEvents;
(function (ServiceWorkerEvents) {
    ServiceWorkerEvents["SaveICHostInfo"] = "SaveICHostInfo";
})(ServiceWorkerEvents || (ServiceWorkerEvents = {}));
